import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Menu, message, Badge, Dropdown, Space, Button } from "antd";
import {
  MenuOutlined,
  BellOutlined,
  UserOutlined,
  LogoutOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import * as userActions from "../../../../actionCreators/User";
import * as propertyActions from "../../../../actionCreators/Property";
import "./style/index.css";
import PageVisibility from "react-page-visibility";

const DashboardHeader = ({
  onCollapse,
  logOut,
  currentUser,
  getNotificationCount,
  notificationCount,
  toggleNotifications,
}) => {
  const history = useHistory();
  const [count, setCount] = useState(null);
  // steadyNotificationCount is steadily a defined number, unlike notificationCount which fluctuates.
  const [steadyNotificationCount, setSteadyNotificationCount] = useState(null);
  useEffect(() => {
    getNotificationCount();
    if (notificationCount) {
      setCount(notificationCount);
    }
  }, []);

  useEffect(() => {
    if (notificationCount) {
      setCount(notificationCount);
    }
  }, [notificationCount]);

  const handleLogOut = () => {
    logOut();
    message.success("You have successfully logged out");
  };
  const handleNotification = () => {
    toggleNotifications();
  };
  const handleVisibilityChange = (isVisible) => {
    if (isVisible) {
      getNotificationCount();
    }
  };
  let menu = (
    <Menu>

      {currentUser.data.user_roles[0].role_id !== 1 && <Menu.Item
        onClick={() => {
          history.push("/account-settings/profile");
        }}
        icon={<UserOutlined />}
      >
        Account Setting
      </Menu.Item>}
      <Menu.Item onClick={handleLogOut} danger={true} icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <PageVisibility onChange={handleVisibilityChange}>
      <Menu mode="horizontal" className="header-menu">
        <div className="header-menu-main">
          <div className="left-section">
            {React.createElement(MenuOutlined, {
              className: "collapse-icon",
              onClick: onCollapse,
            })}
          </div>
          <div className="right-section">
            {currentUser?.data?.user_roles.findIndex(
              (e) => e.role_id == 2 || e.role_id == 1
            ) >= 0 && (
              <div
                className="notificationIconContainer"
                onClick={handleNotification}
              >
                <Badge size="small" count={count && count}>
                  <BellOutlined className="notificationIcon" />
                </Badge>
              </div>
            )}

            <div>
              <p className="user-name">{currentUser?.data?.full_name}</p>
            </div>
            <Dropdown overlay={menu} className="dropdownArrowIconContainer">
              <Space>
                <CaretDownOutlined className="dropdownArrowIcon" />
              </Space>
            </Dropdown>
          </div>
        </div>
      </Menu>
    </PageVisibility>
  );
};

const mapStateToProps = ({
  user: { currentUser },
  property: { notificationCount },
}) => ({ currentUser, notificationCount });

const mapDispatchToProps = (dispatch) => ({
  logOut: bindActionCreators(userActions.logOut, dispatch),
  getNotificationCount: bindActionCreators(
    propertyActions.getNotificationCount,
    dispatch
  ),
  toggleNotifications: bindActionCreators(
    propertyActions.toggleNotifications,
    dispatch
  ),
});

DashboardHeader.propTypes = {
  toggleNotifications: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  notificationCount: PropTypes.object.isRequired,
  getNotificationCount: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardHeader)
);
